// Rupee amounts are shown to at most two decimals: whole rupees stay whole
// (₹25) and anything with paise shows exactly two (₹22.20, ₹2.80).
//
// Rounds half up via the decimal string, the same way as money() in
// backend/app/utils/money.py, so 2.675 -> 2.68 (plain float maths gives 2.67). It also
// clears float residue from arithmetic done in the browser — a margin of
// 25 - 22.2 is 2.8000000000000007 as a float and displays as 2.80.
export function roundToPaise(n) {
  const abs = Math.abs(n);
  if (abs < 0.005) return 0; // also keeps tiny values out of exponent notation
  // `${abs}e2` shifts the decimal point in the string, avoiding abs * 100 error
  return (Math.sign(n) * Math.round(Number(`${abs}e2`))) / 100;
}

export function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  const rounded = roundToPaise(n);
  const hasPaise = Math.round(Math.abs(rounded) * 100) % 100 !== 0;
  return rounded.toFixed(hasPaise ? 2 : 0);
}

// Time as a bill counts it: whole minutes, never rounded up, so "3m" beside ₹15
// at ₹300/hr always adds up. Anything under a minute reads <1m.
export function formatDuration(minutes) {
  const whole = Math.floor(Number(minutes) || 0);
  if (whole < 1) return "<1m";
  const h = Math.floor(whole / 60);
  const m = whole % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

